import { render, staticRenderFns } from "./ChildGroupFee.vue?vue&type=template&id=577c0dfa&scoped=true&"
import script from "./ChildGroupFee.vue?vue&type=script&lang=js&"
export * from "./ChildGroupFee.vue?vue&type=script&lang=js&"
import style0 from "./ChildGroupFee.vue?vue&type=style&index=0&id=577c0dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577c0dfa",
  null
  
)

export default component.exports